import { css } from 'styled-components';

export const Bold = css`
    font-weight: 700;
`;
export const SemiBold = css`
    font-weight: 600;
`;
export const Medium = css`
    font-weight: 500;
`;

/* istanbul ignore next */
export const Strong = css`
    strong {
        ${Bold};
    }
`;

/* istanbul ignore next */
export const Mark = css`
    mark {
        color: ${({ theme }) => theme.colorSystem.secondary[3]};
        background: none;
    }
`;

export const RegText = css`
    ${Medium};
    font-size: 1rem; // 16px
    line-height: 1.5rem; // 24px
`;

export const SmText = css`
    ${Medium};
    font-size: 0.875rem; // 14px
    line-height: 1.375rem; // 22px
`;

export const XsText = css`
    ${Medium};
    font-size: 0.75rem; // 12px
    line-height: 1.375rem; // 22px
`;

export const CategoryLabels = css`
    ${Medium};
    ${SmText};
`;

export const Breadcrumbs = css`
    ${SemiBold};
    ${RegText};
`;

export const Nav = css`
    ${Bold};
    ${RegText};
`;

export const FooterTitles = css`
    ${SemiBold};
    ${RegText};
`;

export const FooterContent = css`
    ${Medium};
    ${SmText};
`;

export const FormFieldLabel = css`
    ${Medium};
    ${RegText};
`;
export const FormFieldLabelSmall = css`
    ${Medium};
    ${SmText};
`;
export const FormFieldInput = css`
    ${Medium};
    ${RegText};
`;

export const TMText = css`
    margin: 8px 0;
    letter-spacing: 0px;
`;

export const TMHeading = css`
    ${TMText}
    ${Bold}
`;

export const ButtonTxt = css`
    ${RegText};
    ${Bold};
`;

export const Link = css`
    ${Bold};
    text-decoration: underline;
    color: ${({ theme }) => theme.colorSystem.primary[4]};
    &:hover {
        color: ${({ theme }) => theme.colorSystem.primary[1]};
    }
    &:focus {
        color: ${({ theme }) => theme.colorSystem.primary[1]};
    }
`;
